import { InjectionToken } from '@angular/core';
import { Request, Response } from 'express';

export const SERVER_URL_HOST = new InjectionToken<string>('Host from SSR request');
export const NG_API_TIMEOUT_TOKEN = new InjectionToken<number>('Api timeout value');
export const BUILD_TOKEN = new InjectionToken<string>('Current build id');
export const APP_INSIGHTS_TOKEN = new InjectionToken<string>('Application Insights connection string');
export const REQUEST = new InjectionToken<Request>('Server request');
export const RESPONSE = new InjectionToken<Response>('Server response');
